import {appendAttachments} from './conversation-attachments';
import type {FileRecord,ReaderContext} from '@reados/contracts';

// Copied from iPad Resources/Reader.xcstrings: reader.pdf.oneClickConfigure.prompt.
export const PDF_CONFIGURATION_PROMPT='帮我配置这本书的书本页码、目录、知识地图';
export interface PdfConfigurationSource {fileId:string;name:string}
type DraftStorage=Pick<Storage,'getItem'|'setItem'|'removeItem'>;

function stored(storage:DraftStorage,key:string):unknown{
  try{return JSON.parse(storage.getItem(key)??'null');}catch{return null;}
}

export function pdfConfigurationSource(value:unknown):PdfConfigurationSource|null{
  if(!value||typeof value!=='object')return null;
  const candidate=value as Partial<PdfConfigurationSource>;
  return typeof candidate.fileId==='string'&&candidate.fileId&&typeof candidate.name==='string'
    ?{fileId:candidate.fileId,name:candidate.name}:null;
}

/** Prepare a local composer only; durable conversation creation belongs to manual send. */
export function stagePdfConfiguration(storage:DraftStorage,prefix:string,pendingIds:string[],file:FileRecord,makeID:()=>string=()=>crypto.randomUUID()):string{
  if(file.kind!=='pdf')throw new Error('请先选择需要配置的 PDF。');
  const existing=pendingIds.find(id=>id.startsWith('pending:')
    &&pdfConfigurationSource(stored(storage,`${prefix}.${id}.pdfConfiguration`))?.fileId===file.id
    &&!stored(storage,`${prefix}.${id}.createdThreadId`));
  if(existing)return existing;
  const id=`pending:${makeID()}`,key=`${prefix}.${id}`;
  try{
    storage.setItem(`${key}.pdfConfiguration`,JSON.stringify({fileId:file.id,name:file.name} satisfies PdfConfigurationSource));
    storage.setItem(`${key}.draft`,JSON.stringify(PDF_CONFIGURATION_PROMPT));
    storage.setItem(`${key}.attachments`,JSON.stringify(appendAttachments([],[{kind:'file',resourceId:file.id}])));
  }catch{
    try{storage.removeItem(`${key}.pdfConfiguration`);storage.removeItem(`${key}.draft`);storage.removeItem(`${key}.attachments`);}catch{}
    throw new Error('无法保存配置草稿，请检查浏览器存储后重试。');
  }
  return id;
}

/** Resolve the exact owned catalog ID again before binding a new conversation. */
export function pdfConfigurationFile(source:PdfConfigurationSource,files:FileRecord[]):FileRecord{
  const file=files.find(item=>item.id===source.fileId&&item.kind==='pdf');
  if(!file)throw new Error('要配置的 PDF 已不在资料库中，请重新打开文件后再试。');
  return file;
}

/** The workspace stays truthful even when another PDF becomes visible before sending. */
export function pdfConfigurationContext(context:ReaderContext,source:PdfConfigurationSource):ReaderContext{
  return {fileId:source.fileId,...(context.workspace?{workspace:context.workspace}:{})};
}
